export const OPEN_FAN_KEY = 'job-fuzzy-matrix';

const store = {
	namespaced: true,
	state: {
		show: false,
		job: undefined,
		filterValues: undefined,
		onFilter: undefined,
	},
	actions: {
		show ({commit}, data)
		{
			commit('layout/addOpenFan', OPEN_FAN_KEY, {root: true});

			commit('setJob', data.job);
			commit('setFilterValues', _.cloneDeep(data.filterValues));
			commit('setOnFilter', data.onFilter);

			commit('setShow', true);
		},
		close ({commit, state}, data)
		{
			if (data.confirm && state.onFilter)
			{
				state.onFilter({
					job: state.job,
					filterValues: state.filterValues,
				});
			}

			commit('setShow', false);

			commit('setJob', undefined);
			commit('setFilterValues', undefined);
			commit('setOnFilter', undefined);

			commit('layout/removeOpenFan', OPEN_FAN_KEY, {root: true});
		},
	},
	mutations: {
		setShow: (state, value) => state.show = value,
		setJob: (state, value) => state.job = value,
		setFilterValues: (state, value) => state.filterValues = value,
		setOnFilter: (state, value) => state.onFilter = value,
	},
};

export default store;
